import type {PromptListWidgetPayload, ActionEvent} from '../types';
import * as React from 'react';
import {PromptChip, BodySmallBold} from '@spaced-out/ui-design-system';
import css from './prompt-list-widget.css';


export type PromptListWidgetProps = PromptListWidgetPayload & {
  publishMessageAction?: (action: ActionEvent) => void;
};

export const PromptListWidget = ({
  title,
  prompts,
  publishMessageAction,
}: PromptListWidgetProps) => {
  return (
    <div className={css.container}>
      <div className={css.section} key={title}>
        <BodySmallBold color="secondary" className={css.sectionTitle}>
          {title}
        </BodySmallBold>

        {prompts.map(({prompt, payload}) => {
          return (
            <PromptChip
              key={prompt}
              onClick={() => publishMessageAction?.(payload)}
            >
              {prompt}
            </PromptChip>
          );
        })}
      </div>
    </div>
  );
};
